/* eslint-disable @typescript-eslint/no-explicit-any */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Caption } from '../shared/Caption';
import { HeaderCell, FooterCell, TableRow } from './Layout';
import { LoadMoreButton, TableSpinner } from '../shared';
import { StyledTable } from './styles';
const LoadMoreRow = styled.tr `
  ${({ disableContainer }) => `
    ${disableContainer ? '&&& { border-bottom: none; }' : ''}
  `}
`;
const Spinner = ({ colSpan }) => {
    return (React.createElement("tr", null,
        React.createElement("td", { colSpan: colSpan },
            React.createElement(TableSpinner, null))));
};
const TableVariantRefForwarding = (_a, ref) => {
    var _b, _c, _d, _e, _f;
    var { tableInstance, shared, table, captionRef } = _a, others = __rest(_a, ["tableInstance", "shared", "table", "captionRef"]);
    const { getTableProps, getTableBodyProps, headerGroups, footerGroups, prepareRow, } = tableInstance;
    const { getAriaLiveSort } = table;
    const columnCount = useMemo(() => headerGroups[0].headers.filter(header => !header.isDrawerOnly).length, [headerGroups]);
    // The filter fixes a bug where react-table includes the expanded row's children as
    // part of the row[], causing the parent row to be rendered an additional time per child.
    // Expanded rows have a row.depth of 1, so we filter out rows that have a row depth of 1 or greater.
    const data = !shared.pagination
        ? tableInstance.preExpandedRows
        : tableInstance.page.filter(row => row.depth < 1);
    const paginationInformation = shared.pagination
        ? `Page ${tableInstance.state.pageIndex + 1} of ${tableInstance.pageCount}`
        : undefined;
    return (React.createElement(StyledTable, Object.assign({}, getTableProps(), { disableContainer: shared.disableContainer, fullWidth: table.fullWidth, ref: ref, tabIndex: -1 }, others),
        React.createElement(Caption, { variant: "table", text: shared.captionText, paginationInformation: paginationInformation, size: (_b = table.caption) === null || _b === void 0 ? void 0 : _b.size, isVisible: !!((_c = table.caption) === null || _c === void 0 ? void 0 : _c.isVisible), ref: captionRef }),
        React.createElement("thead", null, headerGroups.map(headerGroup => (React.createElement("tr", Object.assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers
            .filter(header => !header.isDrawerOnly)
            .map(header => (React.createElement(HeaderCell, { key: header.id, column: header, tableCaption: shared.captionText, handleManualSort: shared.handleManualSort, getAriaLiveSort: getAriaLiveSort }))))))),
        React.createElement("tbody", Object.assign({}, getTableBodyProps()), shared.isLoading ? (React.createElement(Spinner, { colSpan: columnCount })) : (React.createElement(React.Fragment, null,
            data.map((row, index) => {
                var _a;
                prepareRow(row);
                return (React.createElement(TableRow, { key: row.id, table: table, tableInstance: tableInstance, currentRow: {
                        index,
                        data: row,
                        isFocused: ((_a = shared.loadMoreValues) === null || _a === void 0 ? void 0 : _a.newRowIndex) === index,
                    } }));
            }),
            !!((_d = shared.loadMoreValues) === null || _d === void 0 ? void 0 : _d.canShowMore) && !((_e = table.footer) === null || _e === void 0 ? void 0 : _e.enabled) && (React.createElement(LoadMoreRow, { disableContainer: shared.disableContainer },
                React.createElement("td", { colSpan: columnCount },
                    React.createElement(LoadMoreButton, { loadMoreValues: shared.loadMoreValues }))))))),
        !!((_f = table.footer) === null || _f === void 0 ? void 0 : _f.enabled) && !shared.isLoading && (React.createElement("tfoot", { "data-test-id": "mui-table-footer" }, footerGroups.map(group => (React.createElement("tr", Object.assign({}, group.getFooterGroupProps()), group.headers.map((column, index) => {
            var _a;
            return (React.createElement(FooterCell, { key: column.id, column: column, isHeader: index === 0 && !((_a = table.footer) === null || _a === void 0 ? void 0 : _a.disableRowHeader) }));
        }))))))));
};
const TableVariant = React.forwardRef(TableVariantRefForwarding);
export { TableVariant };
//# sourceMappingURL=TableVariant.js.map